import { useLocation } from "react-router-dom";

export const SITE_URL = "https://avrah.it";

export const stripLocalePrefix = (pathname = "/") => {
  if (pathname === "/en") return "/";
  if (pathname.startsWith("/en/")) return pathname.slice(3) || "/";
  return pathname || "/";
};

export const localizedPath = (path = "/", lang = "it") => {
  const cleanPath = stripLocalePrefix(path);
  if (lang === "en") return cleanPath === "/" ? "/en" : `/en${cleanPath}`;
  return cleanPath;
};

export const absoluteUrl = (path = "/", lang = "it") =>
  `${SITE_URL}${localizedPath(path, lang)}`;

export const isEnglishPath = (pathname = "/") =>
  pathname === "/en" || pathname.startsWith("/en/");

export const useSeoLinks = (canonicalPath = "/") => {
  const location = useLocation();
  const lang = isEnglishPath(location.pathname) ? "en" : "it";

  return {
    lang,
    canonical: absoluteUrl(canonicalPath, lang),
    alternates: {
      it: absoluteUrl(canonicalPath, "it"),
      en: absoluteUrl(canonicalPath, "en"),
      default: absoluteUrl(canonicalPath, "it"),
    },
    ogLocale: lang === "en" ? "en_US" : "it_IT",
    ogLocaleAlternate: lang === "en" ? "it_IT" : "en_US",
  };
};
